import { BehaviorSubject, skip } from "rxjs";
import { IFilterRequest } from "../../../src/05_components/filter/dto/filter.dto";
import { ISearchRequest } from "../../../src/05_components/search/dto/requestBody.dto";



export class UrlService {
  constructor(private filterElement: HTMLElement, private searchRequest: BehaviorSubject<ISearchRequest>) {
    this.searchRequest.pipe(skip(1)).subscribe((request) => {
      this.updateUrl(request);
    });
  }

  private updateUrl(request: ISearchRequest) {
    const urlParams = new URLSearchParams();

    Object.keys(request.filters)?.forEach(key => {
      const value = request.filters[key];

      if (key === 'orderBy' ||  !!!value || (Array.isArray(value) && value.length == 0)) {
        return;
      }

      if (Array.isArray(value)) {
        urlParams.set(key + '[]', value.toString());
      } else {
        urlParams.set(key, value);
      }
    });

    if (urlParams.toString()) {
      window.history.replaceState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
    } else {
      window.history.replaceState({}, "", `${window.location.pathname}`);
    }
  }
}
